/* ==========================================================================
   Swaballs custom UI (classic script, event-delegated so it survives
   Horizon section re-renders / theme-editor updates).
   - Accessible size-guide tabs (ARIA tablist)
   - Truly seamless marquee (clones phrases until the run exceeds the
     viewport, so there is never a gap — at any width, re-run on resize)
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Size-guide tabs ---------------- */
  function activate(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = list.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    }
    if (focus) tab.focus();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.sw-sztabs [role="tab"]');
    if (tab) { e.preventDefault(); activate(tab); }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('.sw-sztabs [role="tab"]');
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab), next = null;
    switch (e.key) {
      case 'ArrowRight': case 'ArrowDown': next = tabs[(i + 1) % tabs.length]; break;
      case 'ArrowLeft': case 'ArrowUp': next = tabs[(i - 1 + tabs.length) % tabs.length]; break;
      case 'Home': next = tabs[0]; break;
      case 'End': next = tabs[tabs.length - 1]; break;
    }
    if (next) { e.preventDefault(); activate(next, true); }
  });

  /* ---------------- Seamless marquee ---------------- */
  function setupMarquee(marq) {
    var track = marq.querySelector('.sw-marq-track');
    if (!track) return;

    // Cache one original group as the repeat unit.
    if (!track.getAttribute('data-sw-base')) {
      var g = track.querySelector('.sw-marq-group');
      if (!g) return;
      track.setAttribute('data-sw-base', g.outerHTML);
      // remember the author's speed setting (px/sec baseline) from inline duration
      var setDur = parseFloat(track.style.animationDuration) || 26;
      track.setAttribute('data-sw-speed', String(setDur));
    }

    var groupHTML = track.getAttribute('data-sw-base');
    var container = marq.clientWidth || window.innerWidth || 0;
    if (!container) return;

    // Rebuild: start from one group, clone until the run comfortably exceeds
    // the viewport, then duplicate the whole run so translateX(-50%) is gapless.
    track.innerHTML = groupHTML;
    var guard = 0;
    while (track.scrollWidth < container + 40 && guard < 80) {
      track.insertAdjacentHTML('beforeend', groupHTML);
      guard++;
    }
    var runWidth = track.scrollWidth; // one full run (>= viewport)
    track.innerHTML = track.innerHTML + track.innerHTML; // two identical runs

    // Keep pixel speed consistent across widths (setting default 26 ≈ 46px/s).
    var setting = parseFloat(track.getAttribute('data-sw-speed')) || 26;
    var pxPerSec = 1200 / setting;
    track.style.animationDuration = (runWidth / pxPerSec).toFixed(2) + 's';
  }

  function setupAll() {
    document.querySelectorAll('.sw-marq').forEach(setupMarquee);
  }

  var rt, lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    // Ignore height-only resizes (mobile address-bar hide/show while scrolling),
    // which must NOT rebuild the marquee — that caused a visible jump on scroll.
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    clearTimeout(rt); rt = setTimeout(setupAll, 200);
  });
  window.addEventListener('load', setupAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setupAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll);
  else setupAll();
})();
